export const SelectorIcon: React.FC<React.ComponentProps<"svg">> = ({
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.5245 20.3824C11.7647 20.6944 12.2352 20.6944 12.4754 20.3824L16.4525 15.216C16.7562 14.8214 16.4749 14.25 15.977 14.25H8.02286C7.52495 14.25 7.2437 14.8214 7.54741 15.216L11.5245 20.3824Z"
        fill="currentColor"
      />
      <path
        d="M12.4754 3.61761C12.2352 3.3056 11.7647 3.3056 11.5245 3.61761L7.54741 8.78399C7.2437 9.17853 7.52495 9.74999 8.02286 9.74999H15.977C16.4749 9.74999 16.7562 9.17854 16.4525 8.78399L12.4754 3.61761Z"
        fill="currentColor"
      />
    </svg>
  );
};
